import React from 'react'
import { useState } from 'react';
import './IndustryHelp.css'

export default function IndustryHelp() {
    const [emailInput, setEmailInput] = useState("");
          const [mobileInput, setMobileInput] = useState("");
        
          const [isEmailTouched, setIsEmailTouched] = useState(false);
          const [isMobileTouched, setIsMobileTouched] = useState(false);
        
          const [isEmailValid, setIsEmailValid] = useState(true);
          const [isMobileValid, setIsMobileValid] = useState(true);
        
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const mobileRegex = /^[0-9]{10}$/;
        
          const onEmailChangeHandler = (event) => {
            const value = event.target.value;
            setEmailInput(value);
            setIsEmailTouched(true);
            setIsEmailValid(value.length > 0 && emailRegex.test(value));
          };
        
          const onMobileChangeHandler = (event) => {
            const value = event.target.value;
            setMobileInput(value);
            setIsMobileTouched(true);
            setIsMobileValid(value.length > 0 && mobileRegex.test(value));
          };
        
          const submitHandler = (event) => {
            event.preventDefault();
        
            if (emailInput.trim().length === 0) setIsEmailValid(false);
            if (mobileInput.trim().length === 0) setIsMobileValid(false);
        
            if (isEmailValid && isMobileValid) {
              alert("Form Submitted Successfully!");
              setEmailInput("");
              setMobileInput("");
              setIsEmailTouched(false);
              setIsMobileTouched(false);
            }
          };
  return (
    <div>
      <div className="our-industry-page-help">
      {/* Top Heading */}
      <header className="top-headerindustry-help">
        <h1>WE WILL HELP YOU</h1>
       
      </header>
      <hr className="our-industry-hr"/>

      <div className="our-industry-container">
        {/* Left Side - Fixed Content */}
        <div className="left-side">
          <h2>Order a free consultation - Our experts will select the most effective solution</h2>
          <p></p>
          <form onSubmit={submitHandler}>
            <div className="form-control">
              
              <input
                type="email"
                id="email"
                placeholder="Email*"
                value={emailInput}
                onChange={onEmailChangeHandler}
                onBlur={() => setIsEmailTouched(true)}
              />
              {!isEmailValid && isEmailTouched && emailInput.length === 0 && (
                <p className="error-text">*Email is required</p>
              )}
              {!isEmailValid && isEmailTouched && emailInput.length > 0 && (
                <p className="error-text">*Please enter a valid email</p>
              )}
            </div>

            <div className="form-control">
             
              <input
                type="text"
                id="mobile"
                placeholder="Mobile Number*"
                value={mobileInput}
                onChange={onMobileChangeHandler}
                onBlur={() => setIsMobileTouched(true)}
              />
              {!isMobileValid && isMobileTouched && mobileInput.length === 0 && (
                <p className="error-text">*Mobile number is required</p>
              )}
              {!isMobileValid && isMobileTouched && mobileInput.length > 0 && (
                <p className="error-text">*Please enter a valid 10-digit mobile number</p>
              )}
            </div>

        <div className="form-actions">
          <button type="submit" >
            Order Consultation
          </button>
        </div>
      </form>
        </div>
        <div className="vertical-line-industry-help"></div>

        {/* Right Side - Scrollable Content */}
        <div className="right-side-industry">
        <div className="help-features">
        <div className="feature-item-industry">
          <div className="checkbox-help-industry">✔</div>
          <div>
            <h3>
            GREAT TA COVERAGE</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit arcu accumsan, tristique at vivamus imperdiet sodales taciti iaculis</p>

          </div>
        </div>
        <div className="feature-item-industry">
          <div className="checkbox-help-industry">✔</div>
          <div>
            <h3>CUSTOMER RETENTION</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit arcu accumsan, tristique at vivamus imperdiet sodales taciti iaculis</p>
            
          </div>
        </div>
        <div className="feature-item-industry">
          <div className="checkbox-help-industry">✔</div>
          <div>
            <h3>GREAT SEO</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipiscing elit arcu accumsan, tristique at vivamus imperdiet sodales taciti iaculis</p>
          </div>
        </div>
        <div className="feature-item-industry">
          <div className="checkbox-help-industry">✔</div>
          <div>
            <h3>COST-EFFICIENCY</h3>
            <p>

Lorem ipsum dolor sit amet consectetur adipiscing elit arcu accumsan, tristique at vivamus imperdiet sodales taciti iaculis</p>
          </div>
        </div>
        
       
       
        </div>
      </div>
    </div>
    </div>
    </div>
  )
}
